import React from 'react';
import { IconButton } from '@mui/material';
import { AccountCircleOutlined } from '@mui/icons-material';
import ProfileBtnForm from './form';
import { useAuth } from '@/infrastructure/context/auth-context';
import Image from 'next/image';
import s from './styles.module.scss';

const AppProfileButton: React.FC = () => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const { authUser } = useAuth();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButton aria-label="profile" onClick={handleClick}>
        {authUser && authUser.photoURL ? (
          <Image
            className={s['image']}
            src={authUser.photoURL}
            alt={`${authUser.displayName}`}
            width={24}
            height={24}
            fetchPriority="high"
          />
        ) : (
          <AccountCircleOutlined fontSize="medium" />
        )}
      </IconButton>
      <ProfileBtnForm
        open={open}
        anchorEl={anchorEl}
        handleClose={handleClose}
      />
    </div>
  );
};

export default AppProfileButton;
